import React from 'react';

import {
  FieldValues,
  Path,
  PathValue,
  useController,
  UseControllerProps,
} from 'react-hook-form';
import {
  Checkbox,
  CheckboxProps,
  LbFormControlLabel,
  LbFormControlLabelProps,
} from '@infoods/lifebase-ui';

type LbCheckboxProps<T extends FieldValues, TName extends Path<T>> = Omit<
  UseControllerProps<T, TName>,
  'defaultValue'
> &
  Pick<CheckboxProps, 'disabled' | 'defaultChecked' | 'color'> &
  Pick<LbFormControlLabelProps, 'className' | 'label' | 'align' | 'font'>;

const LbCheckbox = <T extends FieldValues, TName extends Path<T>>({
  control,
  name,
  defaultChecked = false,
  label,
  className,
  rules,
  disabled,
  color,
  align,
  font,
  shouldUnregister,
}: LbCheckboxProps<T, TName>) => {
  const {
    field: { value, onChange, onBlur, ref, name: fieldName },
  } = useController({
    control,
    name,
    defaultValue: defaultChecked as PathValue<T, TName>,
    rules,
    shouldUnregister,
  });

  return (
    <LbFormControlLabel
      control={
        <Checkbox
          checked={value}
          onChange={(event) => onChange(event.target.checked)}
          slotProps={{ input: { ref } }}
          name={fieldName}
          onBlur={onBlur}
          disabled={disabled}
          color={color}
        />
      }
      label={label}
      className={className}
      align={align}
      font={font}
    />
  );
};

export { LbCheckbox };
